import React from "react";

import l from "components/util/l";
import FieldsView from "components/util/changes/ChangeView.sub.Fields.view";

const SIGNS = { added: "+", modified: "~", removed: "−" };
const SIGN_CLASSES = { added: "text-success", modified: "text-warning", removed: "text-danger" };
const ROW_CLASSES = { added: "is-added", modified: "", removed: "is-removed" };

const BlockView = ({ block, entityKey, expandedItemKeys, onToggleItem }) =>
  <>
    <div className="change-view-block-head">
      <span>{block.label}</span>
      <span className="ml-auto">
        <span className="text-success">+{block.counts.added}</span>
        <span className="text-warning ml-2">~{block.counts.modified}</span>
        <span className="text-danger ml-2">−{block.counts.removed}</span>
      </span>
    </div>

    {block.items.map((item) => {
      const itemKey = `${entityKey}/${block.key}/${item.key}`;
      const isExpanded = expandedItemKeys.includes(itemKey);

      return (
        <div key={itemKey} className="change-view-item">
          <div className={`change-view-item-head ${ROW_CLASSES[item.status]}`}
            onClick={() => onToggleItem(itemKey)}>
            <span className={`change-view-item-sign ${SIGN_CLASSES[item.status]}`}>
              {SIGNS[item.status]}
            </span>
            <span>{item.label}</span>
            <span className="change-view-item-fields">
              {item.fields.map((field) => field.label).join(", ")}
            </span>
          </div>
          {isExpanded && <FieldsView fields={item.fields} isShowingHead={false} />}
        </div>
      );
    })}

    {
      block.hiddenCount > 0 &&
      <div className="change-view-hidden-count">
        {l("y {count} más%DF002", { count: block.hiddenCount })}
      </div>
    }
  </>

export default BlockView;
